import { RadialProgress } from '@vizit/atoms';
import { VizitLogo } from '@vizit/icons';
import * as React from 'react';

interface SsoCallbackProps {
  onVerifySession: () => Promise<boolean>;
  onNavigate: (path: string) => void;
}

function SsoCallback(props: SsoCallbackProps) {
  const { onVerifySession, onNavigate } = props;
  const hasStarted = React.useRef(false);
  const mountedRef = React.useRef(false);

  React.useEffect(() => {
    mountedRef.current = true;

    if (!hasStarted.current) {
      hasStarted.current = true;

      const verify = async () => {
        try {
          const success = await onVerifySession();
          if (mountedRef.current) onNavigate(success ? '/' : '/sso');
        } catch {
          if (mountedRef.current) onNavigate('/sso');
        }
      };

      verify();
    }

    return () => {
      mountedRef.current = false;
    };
  }, [onVerifySession, onNavigate]);

  return (
    <div className="flex-grow flex flex-col justify-center items-center gap-8" data-testid="sso-callback-page">
      <VizitLogo aria-label="Vizit Logo" />
      <RadialProgress isIndeterminate size={32} aria-label="Completing sign in" />
    </div>
  );
}

export { SsoCallback };
export type { SsoCallbackProps };
